export default {
  oops: 'Hoppla!',
  validOrigin: 'Bitte wählen Sie einen gültigen Abfahrtsort',
  validDestination: 'Bitte wählen Sie ein gültiges Ziel',
  validOutboundDate: 'Bitte wählen Sie ein gültiges Abreisedatum',
  validReturnDate: 'Bitte wählen Sie ein gültiges Rückreisedatum',
  validChildAges: 'Bitte wählen Sie das Alter aller Kinder aus',
  oneChild: 'Pro Erwachsenem ist nur 1 Kind (Alter 0 bis 2 Jahre) erlaubt',
}
